export const mapWrapperBaseStyles: React.CSSProperties = {
	position: 'relative',
	borderRadius: '0%',
	borderColor: 'black',
	borderWidth: '1px',
	borderStyle: 'solid',
}
